import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { format } from 'date-fns'
import { ActionItemsSection } from './ActionItemsSection'

interface SessionDetailsPanelProps {
  session: {
    ragflow_session_id: string
    chat_assistant: {
      name: string
    }
    visitor_id: string
    visitor_name?: string
    visitor_email?: string
    ip_address: string
    user_agent: string
    referrer?: string
    created_at: string
  }
  messageCount: number
  sessionId: string
}

export function SessionDetailsPanel({
  session,
  messageCount,
  sessionId,
}: SessionDetailsPanelProps) {
  const createdDate = new Date(session.created_at)

  return (
    <div className="space-y-6">
      {/* Session Details Card */}
      <Card>
        <CardHeader>
          <CardTitle>Session Details</CardTitle>
        </CardHeader>
        <CardContent>
          <dl className="space-y-3">
            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Assistant</dt>
              <dd className="text-sm text-muted-foreground text-right">
                {session.chat_assistant.name}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Created</dt>
              <dd className="text-sm text-muted-foreground text-right">
                {format(createdDate, 'MMMM d, yyyy')} at {format(createdDate, 'h:mm a')}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Visitor ID</dt>
              <dd className="text-sm text-muted-foreground font-mono text-xs text-right break-all">
                {session.visitor_id || 'Unknown'}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Visitor Name</dt>
              <dd className="text-sm text-muted-foreground text-right">
                {session.visitor_name || 'Unknown'}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Visitor Email</dt>
              <dd className="text-sm text-muted-foreground text-right break-all">
                {session.visitor_email || 'Unknown'}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">IP Address</dt>
              <dd className="text-sm text-muted-foreground text-right">
                {session.ip_address || 'Unknown'}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">User Agent</dt>
              <dd className="text-sm text-muted-foreground text-right text-xs break-all">
                {session.user_agent
                  ? session.user_agent.substring(0, 50) + (session.user_agent.length > 50 ? '...' : '')
                  : 'Unknown'}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Referrer</dt>
              <dd className="text-sm text-muted-foreground text-right break-all">
                {session.referrer
                  ? session.referrer.substring(0, 30) + (session.referrer.length > 30 ? '...' : '')
                  : 'Unknown'}
              </dd>
            </div>

            <div className="flex justify-between items-start">
              <dt className="font-semibold text-sm">Message Count</dt>
              <dd className="text-sm text-muted-foreground text-right">{messageCount}</dd>
            </div>
          </dl>
        </CardContent>
      </Card>

      {/* Action Items Card */}
      <ActionItemsSection sessionId={sessionId} />
    </div>
  )
}
